import React, { useEffect, useState } from "react";
import { Container, Table, Spinner, Alert } from "react-bootstrap";
import { getLeads } from "../../../api";
import "./leads.css";

const Leads = () => {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    fetchLeads();
  }, []);

const fetchLeads = async () => {
  try {
    setLoading(true);
    const res = await getLeads();
    console.log("Leads API:", res.data);

    // Check if res.data is an array
    if (Array.isArray(res.data)) {
      setLeads(res.data);
    } else {
      setError("Failed to load leads");
    }
  } catch (err) {
    setError("Something went wrong while fetching leads");
  } finally {
    setLoading(false);
  }
};


  return (
    <section className="leads-page">
      <Container>
        <h2 className="page-title">Contact Leads</h2>
        <p className="page-subtitle">
          All enquiries submitted from Contact Us page
        </p>

        {loading && (
          <div className="text-center py-5">
            <Spinner animation="border" />
          </div>
        )}

        {!loading && error && (
          <Alert variant="danger">{error}</Alert>
        )}

        {!loading && !error && leads.length === 0 && (
          <Alert variant="info">No leads found</Alert>
        )}

        {!loading && !error && leads.length > 0 && (
          <div className="table-responsive">
            <Table bordered hover className="leads-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Phone</th>
                  <th>Subject</th>
                  <th>Message</th>
                </tr>
              </thead>
              <tbody>
                {leads.map((lead, index) => (
                  <tr key={lead.id || index}>
                    <td>{index + 1}</td>
                    <td>{lead.name}</td>
                    <td>{lead.email}</td>
                    <td>{lead.phone}</td>
                    <td>{lead.subject}</td>
                    <td className="message-cell">
                      {lead.message}
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )}
      </Container>
    </section>
  );
};

export default Leads;
